import request from "@/utils/request";

export default function sendMsgByPhone(params) {
    return request({
        url: `/common/shortMsg/sendMsgByPhone`,
        method: 'post',
        params
    })
}
